<div class="contents">
  <app-back-button></app-back-button>
  <div class="add-container">
    <div class="add-content">
      <h3>Cadastro de representante</h3>
      <p *ngIf="profileEducationalInstitution">Efectue o cadastro dos representantes da
        {{profileEducationalInstitution.nome}} <b>{{profileEducationalInstitution.sigla}}</b> no sistema</p>

      <form [formGroup]="representacaoForm" (ngSubmit)="onSubmit()" class="add-represent-form">
        <div class="new-represent">
          <i>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none">
              <path
                d="M8 12H16M12 15V8.5M7.8 21H16.2C17.8802 21 18.7202 21 19.362 20.673C19.9265 20.3854 20.3854 19.9265 20.673 19.362C21 18.7202 21 17.8802 21 16.2V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V16.2C3 17.8802 3 18.7202 3.32698 19.362C3.6146 19.9265 4.07354 20.3854 4.63803 20.673C5.27976 21 6.11984 21 7.8 21Z"
                stroke="#4864E1" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </i>

          <h5>Novo representante</h5>
        </div>

        <div class="wrapp-input col-md-12 w-100">
          <div class="file-upload">
            <p-fileupload name="myfile[]" (onSelect)="onSelectedFiles($event)" [multiple]="false"
              accept="image/png, image/jpeg, image/jpg" maxFileSize="2000000000" invalidFileTypeMessageSummary="danger"
              invalidFileTypeMessageDetail="O Ficheiro seleccionado é inválido" invalidFileLimitMessageSummary="danger"
              invalidFileLimitMessageDetail="Ficheiro muito grande. Min: 2MB">
              <ng-template #header let-files let-chooseCallback="chooseCallback" let-clearCallback="clearCallback"
                let-uploadCallback="uploadCallback">
              </ng-template>
              <ng-template #content let-files let-uploadedFiles="uploadedFiles"
                let-removeFileCallback="removeFileCallback" let-chooseCallback="chooseCallback"
                let-removeUploadedFileCallback="removeUploadedFileCallback">
                <a class="circular-upload preview"
                  [ngStyle]="{ 'background-image': imagePreview ? 'url(' + imagePreview + ')' : 'none' }">
                  <span *ngIf="!imagePreview">Foto</span>
                  <div class="icon" (click)="choose($event, chooseCallback)">
                    <img src="icons/camera-01.svg" alt="">
                  </div>
                </a>
                <!-- <button pButton type="button" label="Guardar Foto" class="p-button-primary mt-2" (click)="savePhoto()"></button> -->
              </ng-template>
              <ng-template #file></ng-template>
              <ng-template #empty></ng-template>
            </p-fileupload>
          </div>
        </div>

        <div class="p-fluid grid w-100">

          <div class="field col-6 d-flex flex-column">
            <label for="nacionalidade">Nacionalidade</label>
            <p-select [filter]="true" appendTo="body" id="nacionalidade" class="w-full" optionLabel="designacao"
              optionValue="id" [options]="nacionalidades" formControlName="NacionalidadeEnum"
              placeholder="Seleccione a nacionalidade" />
          </div>

          <div class="field col-6 d-flex flex-column">
            <label for="bi">Número de identificação</label>
            <div class="flex align-items-center relative w-100">
              <input id="bi" type="text" class="w-full pr-4" pInputText formControlName="bi"
                placeholder="Informe o número do bilhete de identidade" />
              <button pButton *ngIf="isInternalInstitution" [disabled]="f.bi?.invalid" type="button" icon="pi pi-search"
                class="search-btn" (click)="searchDocumentNumber()" aria-label="Search"></button>
            </div>
          </div>

          <div class="field col-6 d-flex flex-column">
            <label for="nome">Nome</label>
            <input id="nome" type="text" class="w-full" pInputText formControlName="nome" placeholder="Digite o nome"
              [disabled]="f.nome?.disabled ?? false" />
            <div *ngIf="f.nome?.invalid && f.nome?.touched" class="error error-message">
              Nome é obrigatório
            </div>
          </div>

          <div class="field col-6 d-flex flex-column">
            <label for="contacto">Telefone</label>
            <!-- <input id="contacto" type="text" class="w-full" pInputText formControlName="telefone" /> -->
            <ng-container *ngIf="isInternalInstitution; else foreignPhone" class="w-full col-6">
              <p-inputmask class="w-full d-grid" id="telefone" mask="+244 999 999 999" formControlName="telefone"
                placeholder="+244 999 999 000" />
            </ng-container>
            <ng-template #foreignPhone>
              <input id="contacto" type="number" class="w-full" pInputText formControlName="telefone"
                placeholder="Digite o telefone com código do país" />
            </ng-template>
            <div *ngIf="f.telefone?.invalid && f.telefone?.touched" class="error error-message">
              Telefone é obrigatório e deve conter apenas números
            </div>
          </div>

          <div class="field col-6 d-flex flex-column">
            <label for="email">Email</label>
            <input id="email" type="email" class="w-full" pInputText formControlName="emailRepresentante"
              placeholder="Digite o email" />
            <div *ngIf="f.emailRepresentante?.invalid && f.emailRepresentante?.touched" class="error error-message">
              Email é obrigatório e deve ser válido
            </div>
          </div>

          <div class="field col-6 d-flex flex-column">
            <label for="typeRepre">Tipo de representação</label>
            <p-select [filter]="true" appendTo="body" id="tipoRepresentacao" class="w-full" optionLabel="designacao"
              optionValue="id" [options]="tiposRepresentacao" placeholder="Seleccione o tipo de representação"
              formControlName="tipoRepresentacaoID" />
            <div *ngIf="f.tipoRepresentacaoID?.invalid && f.tipoRepresentacaoID?.touched" class="error error-message">
              Tipo de representação é obrigatório
            </div>
          </div>

          <div class="d-flex"></div>
          <div class="d-flex justify-content-end w-full">
            <button pButton type="submit"
              [label]="editIndex != null ? 'Editar Representante' : 'Adicionar Representante'"
              class="p-button-primary "></button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="representantes-list list">
    <ng-container *ngIf="representantes.length > 0; else noRepresentantes">
      <app-representante-card *ngFor="let representante of representantes; let i = index"
        [foto]="fotoPreviewMap[representante.id]" [instituicaoEnsino]="profileEducationalInstitution"
        [representante]="representante" (edit)="editRepresentante($event, i)" (delete)="deleteRepresentante($event, i)"
        (notificar)="notificarRepresentante($event)">
      </app-representante-card>
    </ng-container>
    <ng-template #noRepresentantes>
      <p class="empty-message d-flex align-items-center justify-content-center w-100">Não há representantes cadastrados.
      </p>
    </ng-template>
  </div>

  <div class="modal-footer" style="margin-top: 5px !important; padding: 1rem 1rem 2rem 0rem;">
    <!-- <button pButton type="button" label="Cancelar" class="p-button-outlined" (click)="cancel()"></button> -->

    <button pButton type="submit" class="p-button-primary" (click)="save(representantes)" [disabled]="isLoading">
      <ng-container *ngIf="isLoading; else saveLabel">
        <i class="pi pi-spin pi-spinner"></i> Guardando...
      </ng-container>
      <ng-template #saveLabel>Guardar</ng-template>
    </button>
  </div>
</div>

<p-confirmdialog>
  <ng-template #message let-message>
    <div class="flex flex-col items-center w-full gap-4 border-b border-surface-200 dark:border-surface-700">
      <i [ngClass]="message.icon" class="!text-6xl text-primary-500"></i>
      <p>{{ message.message }}</p>
    </div>
  </ng-template>
</p-confirmdialog>
<p-toast></p-toast>
<!-- <p-confirmDialog key="confirmDialog" (onConfirm)="onConfirmSave($event)" (onReject)="onRejectSave()"></p-confirmDialog> -->